var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPage403(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 263.066,
    height: 268.786,
    viewBox: "0 0 263.066 268.786",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "download_1_",
    "data-name": "download (1)",
    transform: "translate(-163.26 -158.63)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M298.321,177.13A125.811,125.811,0,1,0,424.132,302.941,125.746,125.746,0,0,0,298.321,177.13Zm0,240.184A114.373,114.373,0,1,1,412.694,302.941,114.505,114.505,0,0,1,298.321,417.314Z",
    transform: "translate(-3.531 -7.062)",
    fill: "#d0d2d5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M319.507,232.63a91.5,91.5,0,1,0,91.5,91.5A91.6,91.6,0,0,0,319.507,232.63Zm0,171.563a80.066,80.066,0,1,1,80.066-80.066A80.157,80.157,0,0,1,319.507,404.193Z",
    transform: "translate(-24.717 -28.248)",
    fill: "#d0d2d5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M180.417,510.12a17.157,17.157,0,1,0,17.157,17.157A17.177,17.177,0,0,0,180.417,510.12Zm0,22.876a5.719,5.719,0,1,1,5.719-5.719A5.725,5.725,0,0,1,180.417,533Z",
    transform: "translate(0 -134.175)",
    fill: "#d0d2d5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M537.626,204.382a22.876,22.876,0,1,0-22.876-22.876A22.9,22.9,0,0,0,537.626,204.382Zm0-34.314a11.438,11.438,0,1,1-11.438,11.438A11.451,11.451,0,0,1,537.626,170.068Z",
    transform: "translate(-134.175)",
    fill: "#d0d2d5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M572.428,488.089a5.719,5.719,0,1,1-5.719-5.719,5.718,5.718,0,0,1,5.719,5.719",
    transform: "translate(-151.827 -123.582)",
    fill: "#d0d2d5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M535.438,562.09a5.719,5.719,0,1,1-5.719-5.717,5.718,5.718,0,0,1,5.719,5.717",
    transform: "translate(-137.706 -151.832)",
    fill: "#d0d2d5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M257.948,580.589a5.719,5.719,0,1,1-5.719-5.719,5.72,5.72,0,0,1,5.719,5.719",
    transform: "translate(-31.779 -158.892)",
    fill: "#d0d2d5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M248.7,182.849a5.719,5.719,0,1,1-5.719-5.719,5.72,5.72,0,0,1,5.719,5.719",
    transform: "translate(-28.248 -7.062)",
    fill: "#d0d2d5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M183.948,247.6a5.719,5.719,0,1,1-5.719-5.719,5.72,5.72,0,0,1,5.719,5.719",
    transform: "translate(-3.531 -31.779)",
    fill: "#d0d2d5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M572.428,266.1a5.719,5.719,0,1,1-5.719-5.717,5.718,5.718,0,0,1,5.719,5.717",
    transform: "translate(-151.827 -38.843)",
    fill: "#d0d2d5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M285.032,317.326a5.721,5.721,0,0,0-8.827.908,68.639,68.639,0,0,0,95.017,95.017,5.723,5.723,0,0,0,.908-8.827ZM293.2,396.26a57.448,57.448,0,0,1-10.958-65.549l76.511,76.511a57.185,57.185,0,0,1-65.549-10.96Z",
    transform: "translate(-38.844 -59.94)",
    fill: "#d0d2d5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M313.616,280.826a5.724,5.724,0,0,0-.908,8.827l87.1,87.1a5.722,5.722,0,0,0,8.827-.908,68.639,68.639,0,0,0-95.017-95.017ZM402.6,363.365l-76.511-76.5a57.21,57.21,0,0,1,76.506,76.509Z",
    transform: "translate(-56.411 -42.372)",
    fill: "#d0d2d5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPage403);
export default __webpack_public_path__ + "static/media/page403.c6fc3859dd6f0f8f55d1cdf3af67416a.svg";
export { ForwardRef as ReactComponent };